import { useNavigate } from '@wfp-common/hooks/useNavigate';
import React from 'react';

export const withNavigate = <T extends object>(Component: React.ComponentType<T>, compName: string) => {
    const WithHooks = (props: Omit<T, 'navigate'>) => {
        const navigate = useNavigate();

        return <Component {...(props as T)} navigate={navigate} />;
    };

    const componentName = Component.displayName || Component.name || compName;

    WithHooks.displayName = `withNavigate(${componentName})`;

    return WithHooks;
};
